import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './componentsCss/ListCardAgreements.css'
import Avatar from '../assets/img/plano-de-saude.svg'
import api from '../api'
import Loading from './Loading'
import Globals from '../Globals'

function ListCardAgreements({ search }) {
    const [data, setData] = React.useState([])

    const [loading, setLoading] = React.useState(false)
    const [page, setPage] = React.useState(1)
    const [finalPage, setFinalPage] = React.useState(null)

    const handleScroll = (event) => {
        if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 90 && !loading && !(page - 1 === finalPage)) {
            getData()
        }
    }

    const getData = (exception = false, page2 = null) => {

        if (((page > finalPage && finalPage !== null) || loading) && exception === false) {
            // Já carregamos todas as páginas disponíveis ou esta carregando
            return;
        }

        setLoading(true)

        if (search !== "") {
            api.get('/api/agreements/search/' + search + '?page=' + String(page2 === null ? page : page2)).then((response) => {
                setData(page2 === null ? data.concat(response.data.data) : response.data.data)
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching agreements:', error);
            }).finally(() => {
                setLoading(false)
            })

        } else {
            api.get('/api/agreements/list?page=' + String(page)).then((response) => {
                setData(data.concat(response.data.data))
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching agreements:', error);
            }).finally(() => {
                setLoading(false)
            })
        }

    }



    useEffect(() => {
        if (search === "") {
            setFinalPage(null)
            setPage(1)
            setData([])

            getData()

        } else {
            getData(true, 1)
        }
    }, [search])

    useEffect(() => {

        var el = document.getElementsByClassName('scroll-list-container')[0]
        var el2 = document.getElementsByClassName('container-scroll')[0]
        if (el.scrollHeight - 50 <= el2.clientHeight) {
            getData()
        }

    }, [page])


    return (
        <div onScroll={handleScroll} className='container-scroll'>
            <div className="row row-subcontainer scroll-list-container">            {
                data.length > 0 ? data.map((agreement, index) => {
                    return <Link key={index} className='col-12 col-sm-6 col-md-6 col-lg-4' style={{ padding: '0px 10px' }} to={"/agreements/" + agreement.id}><div > <div className='card-list-agreements'>
                        {
                            agreement.image === "" || agreement.image === null || agreement.image === undefined ? <div className='avatar-img' >
                                <img alt='avatar' src={Avatar} />
                            </div> : <div style={{ background: 'url(' + Globals.BASE_URL + '/storage/' + agreement.image + ')  0% 0% / cover', }} className='card-list-agreements-img' ></div>
                        }
                        <span className='card-list-agreements-name'>{agreement.name}</span>
                    </div>
                    </div>
                    </Link>
                }) : !loading ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Convênios</h6></div> : console.info("loading")

            }
                {loading ? <Loading /> : <></>}
            </div>
        </div>
    )
}

export default ListCardAgreements;